module.exports = __webpack_public_path__ + "img/whyGreen.3158d6ce.jpg";